import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges multiple class names using clsx and tailwind-merge.
 * @param inputs - The class names to merge.
 * @returns The merged class names.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/***
 *
 *   CLASSHELPER
 *   Helper function for applying SCSS or Tailwind classes
 *
 *   PARAMS
 *   debug: log the output to the console (boolean, optional)
 *   props: props object (object, required)
 *   styles: SCSS or tailwind styles (required)
 *
 **********/
export function ClassHelper(
  styles: Record<string, string>,
  props: Record<string, any>,
  debug?: boolean,
) {
  let str = '';

  if (typeof styles === 'object') {
    if (styles.base) str += styles.base; // always apply base styles

    if (Object.keys(props).length) {
      Object.keys(props).forEach((prop) => {
        if (prop === 'className' && props[prop]) {
          // always apply className and base
          str = str.trim();
          str += ` ${props[prop]}`;
        } else if (props[prop] && styles.hasOwnProperty(prop)) {
          if (debug) console.log('styles', prop, props[prop], styles[prop]);

          str = str.trim();
          str += ` ${styles[prop]}`;
        }
      });
    }
  }

  if (debug) console.log('final.class', str.trim());

  return str.trim();
}
